import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InlineCss from 'react-inline-css'

const styles = `
  .dimmed.dimmable > .ui.animating.dimmer,
  .dimmed.dimmable > .ui.visible.dimmer,
  .ui.active.dimmer {
    background-color: rgb(0, 0, 0);
  }`

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'PreviewModalContainer'

    static propTypes = {
      basic: PropTypes.bool,
      currentIndex: PropTypes.number.isRequired,
      currentPicture: PropTypes.string.isRequired,
      currentRug: PropTypes.object,
      disableRugInformation: PropTypes.bool,
      error: PropTypes.bool,
      expanded: PropTypes.bool,
      next: PropTypes.bool.isRequired,
      open: PropTypes.bool.isRequired,
      pending: PropTypes.bool,
      previous: PropTypes.bool.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      toggle: PropTypes.func.isRequired,
      toggleExpansion: PropTypes.func.isRequired,
    }

    static defaultProps = {
      basic: false,
      currentRug: {},
      disableRugInformation: false,
      error: false,
      expanded: false,
      pending: false,
    }

    handleClickLeft = () => {
      const { currentIndex, setCurrentIndex } = this.props

      setCurrentIndex(currentIndex - 1)
    }

    handleClickRight = () => {
      const { currentIndex, setCurrentIndex } = this.props

      setCurrentIndex(currentIndex + 1)
    }

    handleKeyDown = e => {
      const { next, previous } = this.props

      if (e === 37) {
        if (previous) {
          this.handleClickLeft()
        }
      } else if (e === 39) {
        if (next) {
          this.handleClickRight()
        }
      }
    }

    render() {
      const { expanded } = this.props

      return (
        <div>
          {expanded ? <InlineCss stylesheet={styles} /> : null}

          <WrappedComponent
            handleClickLeft={this.handleClickLeft}
            handleClickRight={this.handleClickRight}
            handleKeyDown={this.handleKeyDown}
            {...this.props}
          />
        </div>
      )
    }
  }

  return Container
}
